import { useCheckoutContext } from "../../Checkout.hooks";
import CheckoutMessage from "../../CheckoutMessage";

export default function WalleyErrorMessage({ message }: { message: string }) {
  const { dictionary } = useCheckoutContext();

  if (message.includes("Not Found")) {
    return (
      <CheckoutMessage type="error">
        {dictionary.walleyUnknownError ??
          "Something went wrong. Please try again later."}
      </CheckoutMessage>
    );
  }

  return <CheckoutMessage type="error">{message}</CheckoutMessage>;
}
